import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { DisplayPatientComparison } from "./DisplayPatientComparison";

interface IWarningPopupToContinueProps {
    onClose: () => void;
    onContinue: () => void;
    warningMessageKey: string;
    patientA: Person;
    patientB: Person;
}

function WarningPopupToContinue({ onClose, onContinue, warningMessageKey, patientA, patientB }: Readonly<IWarningPopupToContinueProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("WarningLabel")}
            showX
            showOverlay
            onClose={onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            variant="neutral"
                            label={getText("CancelLabel")}
                            onClick={onClose}
                        />
                        <ButtonControl
                            variant="brand"
                            label={getText("OKLabel")}
                            onClick={onContinue}
                        />
                    </ButtonGroup>
                </div>
            )}
        >
            <p>{getText(warningMessageKey)}</p>
            <DisplayPatientComparison patientA={patientA} patientB={patientB} />
        </Modal>
    );
}

export { WarningPopupToContinue };
